import { Injectable } from "@angular/core";
import { AuthService } from "../auth/auth.service";
import { formatLocale } from "src/app/plasma-ui-common/utils/format-locale";
import { ConfigService } from "../config/config.service";
import { ACCOUNTS_LOCALE_STORAGE_KEY, PATIENT_WEB_LOCALE_STORAGE_KEY } from "src/app/plasma-ui-common/synlab-access-ui-components/core/constants";
import { LoggerService } from "../logger.service";
import { getLocale } from "src/app/plasma-ui-common/utils/common.utils";

@Injectable({
  providedIn: "root",
})
export class AuthGuard  {
  constructor(
    private authService: AuthService,
    private config: ConfigService,
    private logr: LoggerService) {}
  canActivate() {
    this.getLangCodeBeforeSigninCallback()
    let isLoggedIn = this.authService.isLoggedInObs();

    isLoggedIn.subscribe((loggedin) => {
      if (!loggedin) {
        this.authService.signinRedirectTrigger$.next(Date.now());
      }
    });
    return isLoggedIn;
  }

  private getLangCodeBeforeSigninCallback() {
    const urlParams = new URLSearchParams(window.location.search);
    let langCode = urlParams.get('langCode');

    this.logr.log({getLangCodeBeforeSigninCallback: true});
    this.logr.log({langCode});

    if (langCode) {
      langCode = getLocale(langCode);

      this.logr.log({langCodeFromUrl: langCode});

      const formattedLocale = formatLocale(langCode, <any>this.config._envConfig, true);
      this.logr.log({formattedLocale});
      if (formattedLocale) {
        sessionStorage?.setItem(ACCOUNTS_LOCALE_STORAGE_KEY, formattedLocale);
        localStorage?.setItem(PATIENT_WEB_LOCALE_STORAGE_KEY, formattedLocale);
      }
    }

  }
}
